// extracted by mini-css-extract-plugin
export default {"root":"Card-root","fullExtension":"Card-fullExtension","nextGen":"Card-nextGen","primary":"Card-primary"};